import { render } from "./MessageBubble.vue?vue&type=template&id=8d79b568&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"

import "./MessageBubble.vue?vue&type=style&index=0&id=8d79b568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d79b568"]])

export default __exports__